import { Map as ImmutableMap } from 'immutable';
import IndexUIActions from 'SalesContentIndexUI/data/actions/IndexUIActions';
import SearchResultRecord from 'SalesContentIndexUI/data/records/SearchResultRecord';
import SearchContentTypes from 'SalesContentIndexUI/data/constants/SearchContentTypes';
import getUserView from 'documents-ui/lib/getUserView';
export const updateDocumentBrandInIndex = (result, brandId) => {
  const updatedDescription = JSON.stringify({
    brandId: String(brandId)
  });
  const updatedResult = result.set('description', updatedDescription);
  IndexUIActions.updateResult(updatedResult);
};
export const updateDocumentBrandInIndexFromMetadata = (metadata, brandId) => {
  const documentId = metadata.get('deckId');
  if (!documentId) {
    return;
  }
  const userId = metadata.get('userId');
  const updatedAt = metadata.get('updatedAt');
  const updatedDescription = JSON.stringify({
    brandId: String(brandId)
  });
  const updatedResult = SearchResultRecord.initFromJS({
    contentId: documentId,
    contentType: SearchContentTypes.DOCUMENT,
    name: metadata.get('title'),
    folderId: metadata.get('folderId'),
    updatedAt,
    userId,
    userView: getUserView(userId !== null && userId !== void 0 ? userId : undefined),
    description: updatedDescription,
    metadata: ImmutableMap({
      numShares: metadata.get('numShares') || 0,
      numViews: metadata.get('numViews') || 0,
      thumbnailUrl: metadata.get('thumbnailUrl')
    })
  });
  IndexUIActions.updateResult(updatedResult);
};